export default {
      id: "icon-download-usage",
      viewBox: "0 0 22 23",
      url: __webpack_public_path__ + "icons.svg#icon-download",
      toString: function () {
        return this.url;
      }
    }